// extracted by mini-css-extract-plugin
export default {"LoadingOverlay":"style_LoadingOverlay__TgFcG","fixed":"style_fixed__IYK1X"};